import 'lightbox2/dist/css/lightbox';
import './sass/main.scss';

import 'jquery/dist/jquery';
import 'lightbox2/dist/js/lightbox';
import './js/smoothScroll';
import './js/header';
import './js/form';
